if (!customElements.get('colours-picker')) {
  customElements.define(
    'colours-picker',
    class ColoursPicker extends HTMLElement {
      constructor() {
        super();
        this.SHOPIFY_STORE_DOMAIN = window.location.hostname;
        this.ACCESS_TOKEN = this.dataset.shopifyAccessToken;


        this.metafield_data = JSON.parse(this.dataset.metafieldData);
        this.current_variant_id = this.dataset.currentVariantId;
        this.current_product_id = this.dataset.currentProductId;
        this.colour_label = this.querySelector('#product-colours-value');

        this.colour_options = this.querySelectorAll('.product-colours__option');
        this.getAllProducts();
        this.optionClicked();
      }

      getAllProducts() {
        const uniqueProductIds = [...new Set(this.metafield_data.map(item => item.product_id))];
        const graphqlQuery = `
          query Products {
            nodes (ids: ${JSON.stringify(uniqueProductIds)}) {
              ... on Product {
                id
                title
                handle
                availableForSale
              }
            }
          }
        `;

        try {
          fetch(
            `https://${this.SHOPIFY_STORE_DOMAIN}/api/2024-01/graphql`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/graphql',
                'X-Shopify-Storefront-Access-Token': this.ACCESS_TOKEN,
              },
              body: graphqlQuery,
            }
          ).then(response => response.json())
          .then(data => {
            this.updateProductColours(data);
          });
        } catch (error) {
          console.error('Error:', error)
          return []
        }
      }

      updateProductColours(data) {
        this.colour_options.forEach(option => {
          if (!option.classList.contains('checked')) {
            const product_id = option.dataset.productId;
            data.data.nodes.forEach(node => {
              if (node.id === product_id) {
                option.href = `/products/${node.handle}`;
                option.classList.add('checked');
                if (node.availableForSale == false) {
                  option.setAttribute('disabled', 'disabled')
                }
              }
            })
          }
        });
        let selected_option = false;
        this.colour_options.forEach(option => {
          selected_option = option.classList.contains('selected');
        });
        let option_product_id = '';
        this.colour_options.forEach(option => {
          option_product_id = option.dataset.productId.replace('gid://shopify/Product/', '');
          if (!selected_option && option_product_id == this.current_product_id) {
            option.classList.add('selected');
            selected_option = true;
            this.colour_label.innerHTML = option.dataset?.colourName || '';

            document.querySelectorAll('[data-type="add-to-cart-form"]').forEach((el) => {
              el.appendChild(Object.assign(document.createElement('input'), {
                type: 'hidden',
                name: 'properties[Option]',
                value: option.dataset?.colourName || ''
              }));
            }) 
          }
        })
        document.querySelectorAll('.temporary--colour').forEach((el) => {el?.remove();})
      }

      optionClicked() {
        this.colour_options?.forEach(option => {
          option.addEventListener('click', event => {
            if (event.currentTarget?.dataset?.colourName) {
              this.colour_label.innerHTML = event.currentTarget.dataset.colourName;
            }
          });
        });
      }
    }
  );
}
